export default {
  OrderItemTitle: 'OrderItem',
  buttonnewOrderItem: 'New Order Item',
  buttonnewOrderItemLanguage: 'New OrderItem Language',
  buttonDeleteOrderItem: 'Delete OrderItem',
  buttonDeleteOrderItemLanguage: 'Delete OrderItem Language',
  newOrderItem: 'New OrderItem',
  editOrderItem: 'Edit OrderItem',
  newOrderItemLanguage: 'New OrderItem Language',
  editOrderItemLanguage: 'Edit OrderItem Language',
  OrderItemName: 'OrderItem Name',
  confirmDelete: 'Are you sure you want to delete OrderItem {}?',
  confirmOrderItemLanguageDelete: 'Are you sure you want to delete OrderItem Language {}?',
  confirmDeleteSelected: 'Are you sure you want to delete selected OrderItem?',
  confirmOrderItemLanguageDeleteSelected: 'Are you sure you want to delete selected OrderItem Language?',
  progressMessageDelete: 'Deleting OrderItem {}',
  progressMessageOrderItemLanguageDelete: 'Deleting OrderItem Language {}',
  messageDeleteNotSelected: 'Please select OrderItem to delete',
  messageDeleteLanguageNotSelected: 'Please select OrderItem Language to delete',
  tabWindow: 'Window',
  tabLanguage: 'Language',
  AddPicture: 'Add Picture',
  OrderItemDetail: 'OrderItem Detail',
  copyHeader: 'Copy From Header',
}
